import React, { createContext, useContext, useState } from 'react';

export const languages = {
  fr: { label: 'Français', code: 'FR', flag: '🇫🇷' },
  en: { label: 'English',  code: 'EN', flag: '🇬🇧' },
  es: { label: 'Español',  code: 'ES', flag: '🇪🇸' },
};

const LanguageContext = createContext({ language: 'fr', changeLanguage: () => {} });

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('appLanguage') || 'fr';
  });

  const changeLanguage = (lang) => {
    if (languages[lang]) {
      setLanguage(lang);
      localStorage.setItem('appLanguage', lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
